import request from "./http";
import { PAGOS_ENDPOINT } from "../infrastructure/appConstants";

const creditoService = {
  cargoAmortizarCulqi: (req) =>
    request.post(`${PAGOS_ENDPOINT}/cargo/amortizar-culqi`, req),
  calcularItf: (req) => request.post(`${PAGOS_ENDPOINT}/itf/calcular`, req),
  verificarDisponibilidadPago: () =>
    request.get(`${PAGOS_ENDPOINT}/pago/disponibilidad`),
  cargoAmortizarEnCuenta: (req) =>
    request.post(`${PAGOS_ENDPOINT}/cargo/amortizar-cuenta-prymera`, req),
  validarProgramaEstado: () =>
    request.post(`${PAGOS_ENDPOINT}/validar/programa-estado`),
};

export default creditoService;
